import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'dropbox';


  activeItem: number = 0;



  ngOnInit(): void {
    // Retrieve the active item index from localStorage
    const storedActiveItem = localStorage.getItem('activeItem');
    if (storedActiveItem) {
      this.activeItem = parseInt(storedActiveItem, 12);
    }
  }
  
  setActiveItem(index: number): void {
    this.activeItem = index;
    localStorage.setItem('activeItem', this.activeItem.toString());
  }

  clearActiveItem(): void {
    localStorage.removeItem('activeItem');
  }

  ngOnDestroy(): void {
    this.clearActiveItem();
  }

  onActivate(event: Event){
    window.scroll(0,0)
  }

}
